/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PerformanceOnTimeMonthRow
 */
export interface PerformanceOnTimeMonthRow {
  /**
   * Month label, e.g. "Feb 2026".
   * @type {string}
   * @memberof PerformanceOnTimeMonthRow
   */
  month: string;
  /**
   *
   * @type {number}
   * @memberof PerformanceOnTimeMonthRow
   */
  booked: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceOnTimeMonthRow
   */
  onTime: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceOnTimeMonthRow
   */
  onTimeRate: number;
}

/**
 * Check if a given object implements the PerformanceOnTimeMonthRow interface.
 */
export function instanceOfPerformanceOnTimeMonthRow(
  value: object,
): value is PerformanceOnTimeMonthRow {
  if (!("month" in value) || value["month"] === undefined) return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("onTime" in value) || value["onTime"] === undefined) return false;
  if (!("onTimeRate" in value) || value["onTimeRate"] === undefined)
    return false;
  return true;
}

export function PerformanceOnTimeMonthRowFromJSON(
  json: any,
): PerformanceOnTimeMonthRow {
  return PerformanceOnTimeMonthRowFromJSONTyped(json, false);
}

export function PerformanceOnTimeMonthRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceOnTimeMonthRow {
  if (json == null) {
    return json;
  }
  return {
    month: json["month"],
    booked: json["booked"],
    onTime: json["onTime"],
    onTimeRate: json["onTimeRate"],
  };
}

export function PerformanceOnTimeMonthRowToJSON(
  json: any,
): PerformanceOnTimeMonthRow {
  return PerformanceOnTimeMonthRowToJSONTyped(json, false);
}

export function PerformanceOnTimeMonthRowToJSONTyped(
  value?: PerformanceOnTimeMonthRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    month: value["month"],
    booked: value["booked"],
    onTime: value["onTime"],
    onTimeRate: value["onTimeRate"],
  };
}
